<template>
  <el-row class="text-align-left">
    <el-col :span="24" class="banner">
      <div class="banner-image">
        <img src="../assets/OOCL_logo.svg" class="oocl-logo" style="top: 28px">
        <div class="assessment-intro">
          <div class="assessment-title">{{welcomeTitle}}</div>
          <div class="assessment-wording" v-html="answerPageContent"></div>
        </div>
      </div>
    </el-col>
    <el-col :xl="3" :lg="4" :md="5" :sm="6" style="height:10px"></el-col>
    <el-col :xl="21" :lg="20" :md="19" :sm="18">
      <div class="info-body">{{closeText}}</div>
    </el-col>
    <Footer v-on:init="init"></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Constant from '@/common/Constant';

export default {
  components: {
    Footer
  },
  data () {
    return {
      welcomeTitle: '',
      closeText: '',
      answerPageContent: '',
      isShowBtn: false
    };
  },
  methods: {
    init () {
      let answererName = sessionStorage.getItem(Constant.USER_NAME);
      if (answererName === null) {
        this.$router.go(-1);
        return;
      }
      this.welcomeTitle = this.$store.state.dictionary[1].WELCOME_TITLE_STAKEHOLDER;
      this.answerPageContent = this.replaceAnswererText(Constant.STAKEHOLDER_PAGES_TEXT, this.$store.state.dictionary[1].WELCOME_CONTENT_STAKEHOLDER, answererName);
      this.closeText = this.$store.state.dictionary[4].CLOSE_TEXT;
      this.isShowBtn = true;
    },
    replaceAnswererText (target, info, answererName) {
      info = info.replace(new RegExp(target, 'g'), answererName);
      return info;
    }
  }
};
</script>

<style scoped>
  .text-align-left {
    text-align: left;
  }
  .banner{
    position: fixed;
  }
  .banner-image {
    background-image: url("../assets/assessment_banner.jpg");
    height: 185px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .oocl-logo {
    height: 50px;
    padding-left: 48px;
    padding-top: 50px;
  }

  .assessment-intro {
    display: inline-block;
    color: #fff;
    margin: 0 0 0 88px;
    position: relative;
    top: 35px;
  }

  .assessment-title {
    font-size: 42px;
    font-weight: bold;
  }

  .assessment-wording {
    font-size: 16px;
    margin-top: 15px;
    width: 600px;
  }

  .info-body{
    margin: 50px 40px 0 40px;
    position: relative;
    top: 185px;
  }

  .info-body-title{
    color: #2d2d2d;
    font-weight: bold;
    font-size: 28px;
    margin-bottom: 35px;
  }
  .info-body .el-button{
    width: 230px;
    height: 44px;
    margin-right: 300px;
    margin-top: 100px;
    font-size: 16px;
  }

  /* RWD Support */
  @media screen and (max-width: 1200px) {
    .assessment-title {
      font-size: 36px;
    }
  }

  @media screen and (max-height: 900px){
    .assessment-steps{
      height: 400px;
    }
  }

  @media screen and (max-height: 800px){
    .assessment-steps{
      height: 320px;
    }
  }

  /*rewrite element ui style */
  >>>.el-button{
    border-color: #D63246;
    color: #D63246;
  }

  >>>.el-button:hover{
    border-color: #D63246;
    background-color: #f4dbdb;
    color: #D63246;
  }

  >>>.el-button:focus{
    border-color: #D63246;
    background-color: #f4dbdb;
    color: #D63246;
  }

  >>>.el-button--danger{
    background-color: #D63246;
    border-color: #D63246;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #bf2134;
    border-color: #bf2134;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #bf2134;
    border-color: #bf2134;
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Close.vue